import { render, staticRenderFns } from "./Shift4Payment.vue?vue&type=template&id=511b5096"
import script from "./Shift4Payment.vue?vue&type=script&lang=js"
export * from "./Shift4Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports